export interface ExpenseTypeClass {
    AccountExpenseTypeId: number
    MasterAccountExpenseTypeId:number
    AccountId: number
    ExpenseType: string
    AccountTaxCodeId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    IsQuantityField: boolean
    QuantityFieldCaption: string
    isSelected:number
}


export const expensetypeInitialsForApp = {
    ExpenseType: "",
    IsQuantityField: false,
    QuantityFieldCaption: "",
    AccountTaxCodeId: 0,
    AccountTaxZoneId: 0
}

export const expensetypeInitialsForUpdate = {
    ExpenseType: "",
    IsQuantityField: false,
    QuantityFieldCaption: "",
    AccountTaxCodeId: 0,
    AccountTaxZoneId: 0,
    AccountExpenseTypeId: 0,
    IsDisabled: false,
    TaxCode: ""
}